<template>
<div v-if="isVisible" class="odr-popup-wrap" @click="closePopup">
    <div class="odr-popup" @click.stop>
        <span class="odr-popup__close-btn" @click="closePopup">
            <icon>close</icon>
        </span>
        <slot name="header"></slot>
        <slot name="content"></slot>
    </div>
</div>
</template>

<script>
import { popupBus } from '@/utils/popup-bus';
import '@/scss/blocks/popup.scss';
import { mapGetters } from 'vuex';

export default {
    props: {
        id: {
            type: String,
            default: '',
        },
        'acknowledgement-mandatory': {
            type: String,
            default: '',
        },
    },
    data () {
        return {
            isVisible: false,
        };
    },
    components: {
        icon: require('@clearwave/odoro-markup/lib/vue/icon.vue').default,
    },
    created () {
        popupBus.$on(`open-popup:${this.id}`, this.openPopup);
    },
    methods: {
        openPopup () {
            this.isVisible = true;
        },
        closePopup () {
            const acknowledgementMandatory = this.getAcknowledgement(this.acknowledgementMandatory);
            const require = acknowledgementMandatory.require;
            const acknowledged = acknowledgementMandatory.acknowledged;
            if (acknowledgementMandatory && require && !acknowledged) {
                this.isVisible = true;
                this.$store.commit('flow/SET_ACKNOWLEDGEMENT_ERROR', {
                    acknowledgement: acknowledgementMandatory,
                    showError: true,
                });
            } else {
                this.isVisible = false;
            }
        },
    },
    computed: {
        ...mapGetters('flow', {
            getAcknowledgement: 'getAcknowledgement',
        }),
    },
};
</script>
